

const LayoutTakeover: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>{children}</div>;
};

export default LayoutTakeover;
